import { register, findAll, find } from '../../../Javascript/Utils.js'

const ImageCard = el => {
  const componentPrefix = 'mImageCard'
  const ImageCardToggler = findAll(`.${componentPrefix}-viewToggler`, el)
  const ImageCardCaption = find(`.${componentPrefix}-caption`, el)

  ImageCardToggler.forEach((ImageCardToggler, index) => {
    ImageCardToggler.addEventListener('click', () => {
      findAll(`.${componentPrefix}-viewToggle`, el).forEach((viewToggle, i) => {
        if (viewToggle.classList.contains(`${componentPrefix}-viewToggle--isVisible`)) {
          viewToggle.classList.replace(`${componentPrefix}-viewToggle--isVisible`, `${componentPrefix}-viewToggle--isHidden`)
        } else if (viewToggle.classList.contains(`${componentPrefix}-viewToggle--isHidden`)) {
          viewToggle.classList.replace(`${componentPrefix}-viewToggle--isHidden`, `${componentPrefix}-viewToggle--isVisible`)
        }
      })
      ImageCardCaption.classList.toggle(`${componentPrefix}-caption--isExpanded`)
    })
  })
}

register('ImageCard', ImageCard)
